type CallBellIconProps = {
  size?: number
}

export function CallBellIcon({ size = 24 }: CallBellIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M17.7384 15.9535C18.067 15.9537 18.3337 16.2201 18.3337 16.5487C18.3335 16.8772 18.0669 17.1438 17.7384 17.144H2.26223C1.93362 17.144 1.6672 16.8773 1.66699 16.5487C1.66699 16.22 1.93349 15.9535 2.26223 15.9535H17.7384Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.786 2.85749C12.1146 2.85767 12.3813 3.12487 12.3813 3.4535C12.3811 3.78195 12.1145 4.04856 11.786 4.04874H10.5956V5.26557C12.2718 5.40575 13.8529 6.13266 15.0513 7.33107C16.3906 8.67058 17.1432 10.4878 17.1432 12.3821V13.5725H17.7384C18.067 13.5727 18.3337 13.8392 18.3337 14.1678C18.3335 14.4962 18.0669 14.7628 17.7384 14.763H2.26223C1.93362 14.763 1.6672 14.4963 1.66699 14.1678C1.66699 13.839 1.93349 13.5725 2.26223 13.5725H2.85747V12.3821C2.85747 10.4877 3.6098 8.67062 4.94933 7.33107C6.1479 6.1325 7.72859 5.40561 9.40509 5.26557V4.04874H8.21461C7.886 4.04874 7.61959 3.78206 7.61938 3.4535C7.61938 3.12476 7.88587 2.85749 8.21461 2.85749H11.786ZM10.0003 6.42969C8.42166 6.42969 6.90732 7.05649 5.79103 8.17278C4.67476 9.28906 4.04795 10.8034 4.04795 12.3821V13.5725H15.9527V12.3821C15.9527 10.8036 15.3257 9.28903 14.2096 8.17278C13.0934 7.05657 11.5789 6.42978 10.0003 6.42969Z"
        fill="currentColor"
      />
    </svg>
  )
}
